import {gql} from '@apollo/client';

const BillingProfile = gql`
    fragment BillingProfile on BillingProfile {
        billingProfileId
        title
        attendanceSchedule {
            id
            title
            periods {
                to
            }
            behaviors {
                behaviorId
            }
            fullYear
        }
        billingScheme {
            id
            title
            shortTitle
        }
        fundingTypes {
            id
            title
        }
        annualization {
            invoices
            weeksOfCare
        }
        behaviors {
            behaviorId
        }
    }
`;

export const GetBillingProfiles = gql`
    query GetBillingProfiles($institutionId: InstitutionSetId!) {
        finance {
            billingProfiles {
                list(institutionSetId: $institutionId) {
                    ...BillingProfile
                }
            }
        }
    }
    ${BillingProfile}
`;

export const GetBillingProfilesByIds = gql`
    query GetBillingProfilesByIds($billingProfileIds: [BillingProfileId!]!) {
        finance {
            billingProfiles {
                list(billingProfileId: $billingProfileIds) {
                    ...BillingProfile
                }
            }
        }
    }
    ${BillingProfile}
`;

export const GetBillingProfile = gql`
    query GetBillingProfile($billingProfileId: BillingProfileId!) {
        finance {
            billingProfiles {
                list(billingProfileId: [$billingProfileId]) {
                    ...BillingProfile
                }
            }
        }
    }
    ${BillingProfile}
`;

export const GetBillingProfileOptions = gql`
    query GetBillingProfileOptions(
        $institutionSetId: InstitutionSetId!
        $institutionId: InstitutionId!
        $attendanceScheduleIds: [AttendanceScheduleId!]
    ) {
        finance {
            attendanceSchedules {
                list(institutionSetIds: [$institutionSetId]) {
                    id
                    fullYear
                    title
                }
            }
            oldAttendanceSchedules: attendanceSchedules {
                list(attendanceScheduleIds: $attendanceScheduleIds) {
                    id
                    fullYear
                    title
                }
            }
            billingSchemes {
                list(institutionSetId: $institutionSetId) {
                    id
                    title
                }
            }
            funding {
                types(institutionIds: [$institutionId]) {
                    __typename
                    id
                    title
                }
            }
        }
    }
`;

export const UpsertBillingProfile = gql`
    mutation UpsertBillingProfile(
        $billingProfileId: BillingProfileId
        $attendanceScheduleId: AttendanceScheduleId!
        $fundingTypeIds: [FundingTypeId!]
        $title: Title!
        $institutionSetId: InstitutionSetId!
        $annualization: AnnualizationInput
        $billingScheme: String!
    ) {
        finance {
            billingProfiles {
                upsert(
                    billingProfileId: $billingProfileId
                    attendanceScheduleId: $attendanceScheduleId
                    fundingTypeIds: $fundingTypeIds
                    title: $title
                    institutionSetId: $institutionSetId
                    annualization: $annualization
                    billingScheme: $billingScheme
                ) {
                    ...BillingProfile
                }
            }
        }
    }
    ${BillingProfile}
`;

export const DeleteBillingProfile = gql`
    mutation DeleteBillingProfile($billingProfileId: BillingProfileId!) {
        finance {
            billingProfiles {
                delete(billingProfileId: $billingProfileId)
            }
        }
    }
`;
